import { apiUrl, mainWeb } from '../../config/net'
const index = '/tickets'
// const couponInfo = `${apiUrl}/v0/ordercoupon/getmcouponinfo`
const mainWebUrl = `${mainWeb}/OnlineMall/ajax/MobileOnlineMall.ashx`
const couponInfo = `${apiUrl}/v0/ordercoupon/getusercouponinfo`
const takeTicket = `${apiUrl}/v0/ordercoupon/materialreceive/`
const orderCoupon = `${apiUrl}/v0/ordercoupon/avaliable`

export default {
  mainWebUrl,
  index,
  takeTicket,
  couponInfo,
  orderCoupon
}



// WEBPACK FOOTER //
// ./src/model/tickets/resource-url.js